export default __webpack_public_path__ + "static/media/logo04.79aa7ec5.svg";